<template>
    <VeeForm class="form user-form" @submit="openModal" v-if="isBoosterCCS">
        <MDBCard>
            <div class="py-5 px-5">
                <div class="d-flex justify-content-between pt-2">
                    <h1 v-html="$t('points.sharePointModal.header')"></h1>
                    <button class="action-btn fw-bold bg-white text-uppercase" @click="redirectToBankStatement()"
                        :disabled="loading">{{
                            $t("points.board.buttons.learnMore") }}</button>
                </div>
                <MDBRow>
                    <MDBCol cols="12" md="6">
                        <div class="pt-2">
                            <div>
                                <label for="search" class="label px-3 text-uppercase pt-1">
                                    {{ $t("account.profile.email") }}
                                </label>
                            </div>
                            <div>
                                <Field v-model="email" type="text" class="form-control" aria-describedby="basic-addon1"
                                    :rules="{ required: true, email: true, is_not: user.email }" name="search"
                                    :label="$t('account.profile.email')" />
                            </div>
                        </div>
                        <ErrorMessage name="search" class="text-danger text-small text-end m-0 pt-1" />
                    </MDBCol>

                    <MDBCol cols="12" md="6">
                        <div class="pt-2">
                            <div>
                                <label for="sharedPoints" class="label px-3 text-uppercase pt-1">
                                    {{ $t("points.dashboard.dashboardBox.points") }}
                                </label>
                            </div>
                            <div>
                                <Field v-model="sharedPoints" type="number" class="form-control"
                                    aria-describedby="basic-addon1"
                                    :rules="{ min_value: 1, max_value: maxPoints, required: true }" name="sharedPoints"
                                    :label="$t('points.dashboard.dashboardBox.points')" />
                            </div>

                            <ErrorMessage name="sharedPoints" class="text-danger text-small text-end m-0 pt-1" />
                        </div>
                    </MDBCol>

                    <MDBCol cols="12" md="6">
                        <div class="pt-2">
                            <div>
                                <label for="title" class="label px-3 text-uppercase pt-1">
                                    {{ $t('points.sharePointModal.title') }}
                                </label>
                            </div>
                            <div>
                                <Field v-model="title" type="text" class="form-control" aria-describedby="basic-addon1"
                                    :rules="{ required: true }" name="title"
                                    :label="$t('points.sharePointModal.title')" />
                            </div>
                        </div>
                        <ErrorMessage name="title" class="text-danger text-small text-end m-0 pt-1" />
                    </MDBCol>

                </MDBRow>

                <div class="pt-4">
                    <MDBBtn color="danger" type="submit">{{ $t("global.buttons.sharePoints") }}</MDBBtn>
                </div>
            </div>
        </MDBCard>
    </VeeForm>
    <PageNotFound v-else />

    <MDBModal v-model="modal" tabindex="-1" centered size="xl">
        <MDBCard>
            <div class="py-5 px-5">
                <h1 v-html="$t('points.sharePointModal.header')"></h1>
            </div>
            <MDBRow>
                <MDBCol cols="12" md="12">
                    <div class="pt-2 text-center"> {{ $t("points.sharePointModal.title") }}</div>
                    <div class="text-success fw-bold font-20 text-center text-lowercase">{{ title }}</div>
                    <div class="pt-2 text-center"> {{ $t("account.profile.email") }}</div>
                    <div class="text-success fw-bold font-20 text-center text-lowercase">{{ email }}</div>
                    <div class="pt-2 text-center" v-if="sharedPoints">
                        {{ $t('points.sharePointModal.forShare') }}
                    </div>
                    <div class="text-success fw-bold font-20 text-center text-lowercase" v-if="sharedPoints">
                        {{ sharedPoints }}
                    </div>
                </MDBCol>

                <div class="py-5 px-5">
                    <MDBCol cols="12" md="12">
                        <MDBBtn color="primary" @click="openModal()" class="bg-secondary-gray">{{
                            $t("global.buttons.cancel") }}
                        </MDBBtn>
                        <MDBBtn color="danger" type="button" @click="storeExchange()">{{ $t("global.buttons.confirm") }}
                        </MDBBtn>
                    </MDBCol>
                </div>
            </MDBRow>
        </MDBCard>
    </MDBModal>
</template>

<script setup>
import PageNotFound from "@/views/404.vue";
import { Form as VeeForm, Field, ErrorMessage } from "vee-validate";
import { ref, computed } from "vue";
import { MDBCard, MDBBtn, MDBCol, MDBRow, MDBModal } from "mdb-vue-ui-kit";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

import { PointService } from "@/services/point.service";

import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css"

const store = useStore();
const router = useRouter();
const sharedPoints = ref(0)
const email = ref(null)
const title = ref(null)
const loading = ref(false)

const user = computed(() => store.getters.getMe);
const isBoosterCCS = computed(() =>
    user.value?.compaings?.some(element => element.slug === 'booster-ccs')
);
const maxPoints = computed(() => user.value.points.avail_points);
const modal = ref(false)

const openModal = () => {
    modal.value = !modal.value
}

const storeExchange = async () => {
    loading.value = true
    const data = {
        email: email.value,
        points: sharedPoints.value,
        title: title.value
    }
    const response = await PointService.sharePoints(data)

    if (response?.status == 200) {
        openModal()
    } else {
        let object = response.data.errors

        for (const property in object) {
            const message = `${property}: ${object[property]}`

            toast(message, {
                type: "error",
                theme: "colored",
                transition: toast.TRANSITIONS.SLIDE,
                position: toast.POSITION.BOTTOM_RIGHT,
            });
        }
    }

    loading.value = false
}

const redirectToBankStatement = () => {
    router.push({
        name: "pointsOverview"
    });
}
</script>

<style scoped lang="scss">
@import "@/styles/_variables.scss";

.action-btn {
    height: 49px;
    border: 1px solid #B3B3B3;
    border-radius: 25px 25px 25px 25px;
    padding: 5px 30px;
}
</style>